/** @format */

export const AUTO_MANAGEMENT = 'auto_management';
export const NEW = 'new';
export const UPDATE = 'update';
export const SAVE = 'save';
export const SEND_TO_WAREHOUSE = 'send_to_warehouse';
export const CHECK_SAVE = 'checkSave';
export const CHECKED = 'checked';
export const AUTO_CHECKED = 'auto_checked';
export const UNSOLDED = 'unsolded';
export const UNAVAILABLE = 'notAvailable';
export const ARCHIVED = 'archiviata';
